export default "__VITE_ASSET__BGCh2Dby__"